import React from 'react';
import { Row, Col } from 'antd';
import { PersonaSearchField } from './PersonaSearchField';
import { Persona } from '../../../hooks/usePersonas';

interface PersonasContratoProps {
  personas: Persona[];
  selectedComprador: Persona | null;
  selectedVendedor: Persona | null;
  selectedDestinatario: Persona | null;
  tipoContrato: 'C' | 'V' | '';
  onCompradorSelect: (persona: Persona | null) => void;
  onVendedorSelect: (persona: Persona | null) => void;
  onDestinatarioSelect: (persona: Persona | null) => void;
}

export const PersonasContrato: React.FC<PersonasContratoProps> = ({
  personas,
  selectedComprador,
  selectedVendedor,
  selectedDestinatario,
  tipoContrato,
  onCompradorSelect,
  onVendedorSelect,
  onDestinatarioSelect
}) => {
  // Deshabilitar comprador si es tipo Compra y tiene el padrón 000000
  const compradorDisabled = tipoContrato === 'C' && selectedComprador?.nc === '000000';
  
  // Deshabilitar vendedor si es tipo Venta y tiene el padrón 000000
  const vendedorDisabled = tipoContrato === 'V' && selectedVendedor?.nc === '000000';

  return (
    <Row gutter={[16, 16]}>
      <Col span={8}>
        <PersonaSearchField
          label="Comprador"
          required
          personas={personas}
          selectedPersona={selectedComprador}
          onSelect={onCompradorSelect}
          disabled={compradorDisabled}
        />
      </Col>
      <Col span={8}>
        <PersonaSearchField
          label="Vendedor"
          required
          personas={personas}
          selectedPersona={selectedVendedor}
          onSelect={onVendedorSelect}
          disabled={vendedorDisabled}
        />
      </Col>
      <Col span={8}>
        <PersonaSearchField
          label="Destinatario"
          required
          personas={personas}
          selectedPersona={selectedDestinatario}
          onSelect={onDestinatarioSelect}
        />
      </Col>
    </Row>
  );
};

